angular.module('unergie.main')
.filter('warningsTypes', (ReferencesService) => {
    let data = null
    let serviceInvoked = false

    const realFilter = (value) => data[value] || value

    const filterStub = function (value) {
        if (data === null) {
            if (!serviceInvoked) {
                serviceInvoked = true
                ReferencesService.getRef('warningsTypes').then((mapping) => (data = mapping))
            }
            return 'loading ...'
        }
        return realFilter(value)
    }

    filterStub.$stateful = true
    return filterStub
})
